import React from 'react';
import './index.scss';

 class Contact extends React.Component {
     render(){
         return (
    <div style={{ padding: "4rem", textAlign: "center" }}>
      <h2>Contact</h2>
      <p>Contact form coming soon ✨</p>
    </div>
  );
     }
 }

export default Contact
